import React from 'react'
import styled from 'styled-components'
import classNames from 'classnames'

const Wrapper = styled.div`
  &.css-sticky {
    position: sticky;
    top: ${(props) => props.top}px;

    &:before,
    &:after {
      content: '';
      display: table;
    }
  }

  &.fixed {
    position: fixed;
    top: ${(props) => props.top}px;
  }

  &.fixed-bottom {
    position: absolute;
    top: ${(props) => props.marginTop}px;
  }
`

/**
 * This component is a wrapper that will make a component sticky so that it remains on the screen as the user
 * scrolls vertically.
 *
 * Usage notes:
 *  This component's parent must have position: relative;
 */

export function StickyElem({ disableStickiness = false, stickyThresholdTop = 20, children }) {
  const cssClass = classNames({
    'css-sticky': !disableStickiness,
  })

  return (
    <Wrapper className={cssClass} top={stickyThresholdTop} marginTop={stickyThresholdTop || 0}>
      {children}
    </Wrapper>
  )
}
